// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"56e7e545","537":"509630b3","625":"cf5de27c","690":"9ce35654","801":"c3b962aa"}[chunkId] + ".css";
};